import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { SplitFactoryProvider } from '@splitsoftware/splitio-react'

import { selectOrganisationId } from '@/app/slices/organisationSlice'
import { usePostHogIdentity } from '@/common/hooks/usePostHogIdentity'

const SplitProviderWrapper = ({ children }) => {
    const organisationId = useSelector(selectOrganisationId)

    // QM-3562: this wrapper sits above the router, so it's the right place to resolve PostHog
    // identity before any flag-gated component reads useFeatureFlags.
    usePostHogIdentity()

    // Derive Split configuration from organisation user - memoized to prevent unnecessary re-renders
    const splitConfig = useMemo(
        () => ({
            core: {
                authorizationKey: import.meta.env.VITE_SPLIT_APIKEY,
                key: organisationId || 'anonymous',
                trafficType: organisationId ? 'organisation' : undefined,
            },
        }),
        [organisationId]
    )

    return <SplitFactoryProvider config={splitConfig}>{children}</SplitFactoryProvider>
}

export default SplitProviderWrapper
